/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { formatDate } from 'services/utils';
import IconifyIcon from 'components/icon';
import StatusBadge from 'components/custom/ui/StatusBadge';
import { getStatus } from 'helpers/status-badge';

const holidayListColumn = [
  {
    accessorKey: 'title',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <IconifyIcon
              icon="fluent:number-symbol-16-regular"
              fontSize={16}
              className="text-primary-600 dark__text-primary-300"
            />
          </div>
          <span>Title</span>
        </div>
      );
    },
    meta: {
      headerProps: { className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0 text-primary' }
    }
  },
  {
    id: 'from_date',
    accessorKey: 'from_date',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-warning-100 rounded me-2">
            <IconifyIcon
              icon="mdi:clock"
              fontSize={16}
              className="text-warning-600 dark__text-warning-300"
            />
          </div>
          <span>From Date</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { from_date } = original;
      return <p className="mb-0 fs-9 ">{formatDate(from_date, 'DD MMM YY')}</p>;
    },
    meta: {
      cellProps: { className: ' white-space-nowrap' },
      headerProps: { className: 'text-1100' }
    }
  },

  {
    id: 'to_date',
    accessorKey: 'to_date',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-warning-100 rounded me-2">
            <IconifyIcon
              icon="mdi:clock"
              fontSize={16}
              className="text-warning-600 dark__text-warning-300"
            />
          </div>
          <span>To Date</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { to_date } = original;
      return <p className="mb-0 fs-9 ">{formatDate(to_date, 'DD MMM YY')}</p>;
    },
    meta: {
      cellProps: { className: ' white-space-nowrap' },
      headerProps: { className: 'text-1100' }
    }
  },

  {
    accessorKey: 'no_of_days',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <IconifyIcon
              icon="clarity:date-line"
              fontSize={16}
              className="text-info-600 dark__text-primary-300"
            />
          </div>
          <span>No. of Days</span>
        </div>
      );
    },
    meta: {
      headerProps: { className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0' }
    }
  },
  {
    accessorKey: 'status',
    header: 'status',
    cell: ({ row: { original } }) => (
       <StatusBadge
        status={original.status}
        getStatus={getStatus}
        lastComment={original.last_comment}
        flag={original.change_flag}
      />
    )
  }
];

export default holidayListColumn;
